import { createClient } from 'contentful';

const contentClient = createClient({
  space: 'xkzg1k2lc45b',
  accessToken: '00fa10004ace9ec3723917ed7f87ee0ed7022d338558e05a4b452ef820b9d1dd',
});

export default contentClient;